export default __webpack_public_path__ + "static/icon-28-6-be3fc42de87a10ebf6c176deaac33c39.png";